import * as echarts from "echarts";
import ReactECharts from "echarts-for-react";
import { useEffect, useMemo, useRef, useState } from "react";
import { CircularProgress, Paper } from "@mui/material";
import Box from "@mui/material/Box";
import PropTypes from "prop-types";
import { getMapData } from "../../services/DashBoardService";
import UnitConverterWeight from "../../utils/UnitConverter";
import KeycloakService from "../../services/KeycloakService";
import { useAppSelector } from "../../services/StoreHooks";
import { MILLER_UI_TEXT } from "../../textConstant";

const globaloptions = {
  title: {
    text: "title",
    right: 20,
    textStyle: {
      fontWeight: "bold",
    },
  },
  tooltip: {
    trigger: "item",
    formatter: "{b}: {c}",
    confine: true,
  },
  visualMap: {
    min: 0,
    max: 100,
    left: "left",
    bottom: "bottom",
    calculable: false,
    text: ["High", "Low"],
    inRange: {
      color: ["#F1E0DE", "#F6E8CA", "#FEF9B3", "#C5FCBD", "#73FED1"],
    },
    textStyle: {
      color: "#000",
    },
  },
  toolbox: {
    show: true,
    orient: "horizontal",
    left: "left",
    top: "2px",
    feature: {
      restore: {
        title: "Reset Map",
        icon: "path://M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448c106.5 0 204.1-37.6 280.4-100.1l-67.1-73.1C659.4 864.5 588.2 896 512 896 317.5 896 160 738.5 160 544S317.5 192 512 192c123.7 0 233.2 64.6 297.5 162.8L736 384h192V192l-72.7 72.7C784.4 156.6 654.7 64 512 64z",
        iconStyle: {
          color: "#0075ff",
          borderColor: "#0075ff",
          borderWidth: 1,
          shadowBlur: 4,
          shadowColor: "rgba(0, 0, 0, 0.3)",
        },
        emphasis: {
          iconStyle: {
            color: "#0075ff",
            borderColor: "#0075ff",
          },
        },
      },
    },
  },
  series: [],
};

export default function Mapcomponent(props) {
  const categoryNameToIdSelectorRedux = useAppSelector(
    (state) => state?.categoriesData?.categories
  );

  const categoryNameToIdMapRedux = useMemo(() => {
    return categoryNameToIdSelectorRedux.reduce((acc, current) => {
      acc[current.name] = current.id.toString();
      return acc;
    }, {});
  }, [categoryNameToIdSelectorRedux]);

  const userDetails = KeycloakService.getUserDetail();
  const isTheMonitorNotCountry =
  !!userDetails.stateGeoId || !!userDetails.districtGeoId;

  const {
    dashboardType,
    categoryname,
    selectedCategoryId,
    setGridlevel,
    geoId,
    gridlevel,
    selectedTab,
    selectedDates,
  } = props;



  const isNfpbFrk =
    categoryname === "NFPB" &&
    selectedCategoryId == categoryNameToIdMapRedux["FRK"];
  const isNfpbMiller =
    categoryname === "NFPB" &&
    selectedCategoryId == categoryNameToIdMapRedux["MILLER"];

  const chartRef = useRef(null);
  const [options, setOptions] = useState(globaloptions);
  const [enhancedStateData, setEnhancedStateData] = useState([]);
  const [currentStateData, setCurrentStateData] = useState(null);
  const [currentMapLevel, setCurrentMapLevel] = useState("country");

  const [isDrilledDown, setIsDrilledDown] = useState(false);
  const [loader, setLoader] = useState(true);
  const labels = {
    masters: "total",
    production: "totalProduction",
    testing: selectedTab == "2" ? "lotApproved" : "batchTested",
    samples: "testedCount",
  };
  const paramtexts = {
    totalTestedQuantity: "Total Tested",
    underTestingQuantity: "Under Testing",
    batchTestApprovedQuantity: "Batches Approved quantity",
    batchTestRejectedQuantity: "Batches Rejected quantity",
    lotTestApprovedQuantity: "Lots Approved quantity",
    lotTestRejectedQuantity: "Lots Rejected quantity",
    producedQuantity: "Produced",
    inProductionQuantity: "In Production",
    inTransitCount: "In Transit",
    underTestingCount: "Under Testing",
    testedCount: "Tested",
    rejectedCount: "Rejected",
    total: "Total",
    totalProduction: "Total Production",
    sampleInTransit: "Sample in Transit for testing",
    availableTested:
      dashboardType == "testing" ? "Not Dispatched" : "Available Tested",
    batchTested: "Batch Tested",
    lotApproved: "Lot Approved",
    lotRejected: "Lot Rejected",
    lotInTransit: "Lot In Transit",
    batchApproved: "Batch Approved",
    batchRejected: "Batch Rejected",
    totalDispatched: "Total Dispatched",
    usedQuantity: "Quantity Consumed",
    accepted: "Accepted",
    rejected: "Rejected",
    dispatched: "Dispatched",
    available: "Available",
    batchNotTested: "Batch Not Tested",
  };
  const maplabel = labels[dashboardType];
  const maptitles = (dashboardType, categoryname, regionName) => {
    let title = "";
    if (dashboardType == "masters") {
      if (categoryname.toLowerCase() == "all") {
        categoryname = "";
      }
      title = `Total ${
        categoryname == "MILLER" ? MILLER_UI_TEXT : categoryname
      }${categoryname !== "LABS" ? " manufacturers" : ""} in ${regionName}`;
    } else if (dashboardType == "production") {
      if (categoryname === "SCHOOL") {
        title = `Total ${
          selectedCategoryId == categoryNameToIdMapRedux["FRK"]
            ? "FRK"
            : "Fortified Rice"
        } available in ${
          selectedTab == "2" ? "Empaneled" : ""
        } Schools in ${regionName}`;
      } else if (isNfpbFrk) {
        title = `Total FRK available with NFPB in ${regionName}`;
      } else if (isNfpbMiller) {
        title = `Total Fortified Rice production by NFPB in ${regionName}`;
      } else {
        title = `Total ${
          categoryname == "MILLER" ? "Fortified Rice" : categoryname
        } Production in ${regionName}`;
      }
    } else if (dashboardType == "testing") {
      title = `${selectedTab == "2" ? "Empaneled" : "Tested"} ${
        categoryname == "MILLER" || categoryname == "SCHOOL"
          ? "Fortified Rice"
          : categoryname
      } in ${regionName}`;
    } else {
      title = `Tested ${
        categoryname == "MILLER" ? "Fortified Rice" : categoryname
      } Samples in ${regionName}`;
    }
    return title;
  };
  const getparams = (data) => {
    if (!data) {
      console.log("No data provided to getparams");
      return { params: [], paramnames: [] };
    }
    if (data.length === 0) {
      console.log("Empty data array provided to getparams");
      return { params: [], paramnames: [] };
    }
    let params = Object.keys(data[0]);
    // let params = Object.keys(data[0] || data['data']);
    params = params.filter((item) => {
      if (categoryname === "SCHOOL") {
        paramtexts["inProductionQuantity"] = "Total Available";
        return !["id", "producedQuantity"].includes(item);
      }
      return item !== "id" && item !== "categoryId" && item !== "geoId";
    });

    const paramnames = params.map((item) => paramtexts[item]);
    return { params, paramnames };
  };
  // Properly initialize defaultstatsobj with default values
  const defaultstatsobj = {
    label: "No Data",
    data: [],
    enableDrilldown: false,
    value: 0,
  };

  const setStats = (data, params) => {
    if (!params || !Array.isArray(params) || params.length === 0) {
      console.warn("No valid params provided to setStats");
      return {};
    }

    let statsobj = {};

    if (!Array.isArray(data)) {
      console.warn("Data is not an array in setStats");
      return statsobj;
    }

    for (let i of data) {
      if (!i["id"]) {
        console.warn("Item without ID found in data:", i);
        continue;
      }
      statsobj[i["id"].toString()] = {
        data: params.map((param) => {
          if (param == "totalTestedQuantity") {
            return (
              UnitConverterWeight(
                i[param] + (i["totalLotTestedQuantity"] || 0)
              ) || 0
            );
          }
          return ["production", "testing"].includes(dashboardType)
            ? UnitConverterWeight(i[param]) || 0
            : i[param] || 0;
        }),
        label: getLabel(i),
        enableDrilldown: true,
        value: getValue(i[maplabel], i),
      };
    }
    return statsobj;
  };

  // Helper function to calculate production total
  const calculateProductionTotalLabel = (data, isSchoolOrFrk) => {
    const key = isSchoolOrFrk ? "available" : "totalProduction";
    return Array.isArray(data) 
      ? data.reduce((total, element) => total + (element[key] || 0), 0)
      : data[key] || 0;
  };

  // Helper function to calculate testing total
  const calculateTestingTotalLabel = (data, isLotApproved) => {
    const key = isLotApproved ? "lotApproved" : "batchTested";
    return Array.isArray(data) 
      ? data.reduce((total, element) => total + (element[key] || 0), 0)
      : data[key] || 0;
  };

  const getLabel = (i) => {
    // Handle production dashboard type
    if (dashboardType === "production") {
      const isSchoolOrIsNfpbFrk = (categoryname === "SCHOOL") || isNfpbFrk;
      const data = i["data"] || [i];
      const total = calculateProductionTotalLabel(data, isSchoolOrIsNfpbFrk);
      return UnitConverterWeight(total);
    } 
    
    // Handle testing dashboard type
    if (dashboardType === "testing") {
      const isLotApproved = selectedTab === "2";
      const data = i["data"] || [i];
      const total = calculateTestingTotalLabel(data, isLotApproved);
      return UnitConverterWeight(total);
    }
    
    // Default case
    return i[maplabel];
  };

  const getValue = (v, i) => {
    if (dashboardType === "production") {
      if (categoryname === "SCHOOL" || isNfpbFrk) {
        return Number(i["available"]) || 0;
      }
      return Number(i["totalProduction"]) || 0;
    } else if (dashboardType === "testing") {
      return Number(v) || 0;
    }
    return v || 0;
  };

  const fetchMapData = async (mapKeys, selectedCategoryId, type, geoId) => {
    if (mapKeys[0] == "provinces") {
      setLoader(true);
    }
    try {
      const [mapData, res] = await Promise.all([
        fetch(`/${mapKeys.join("/")}.geojson`).then((res) => res.json()),
        getMapData(
          dashboardType,
          dashboardType === "masters" && categoryname === "SCHOOL"
            ? categoryNameToIdMapRedux["SCHOOL"]
            : selectedCategoryId,
          type,
          geoId,
          categoryname,
          null,
          selectedTab,
          selectedDates,
          categoryname === "NFPB" &&
            selectedCategoryId == categoryNameToIdMapRedux["FRK"]
            ? true
            : false
        ),
      ]);
      const stats = res.data;

      if (stats && stats["data"]) {
        const { params, paramnames } = getparams(stats["data"]);
        setLoader(false);
        return { mapData, stats, params, paramnames };
      } else if (stats) {
        const { params, paramnames } = getparams(stats);
        setLoader(false);
        return { mapData, stats, params, paramnames };
      } else {
        console.error("No stats data returned from API");
        setLoader(false);
        return { mapData, stats: {}, params: [], paramnames: [] };
      }
    } catch (error) {
      console.error("Error fetching map data:", error);
      setLoader(false);
      return { mapData: {}, stats: {}, params: [], paramnames: [] };
    }
  };

  const loadDrilledDownMap = (stateGeoId, stateName) => {
    console.log(
      `Loading drilled down map for state: ${stateName} (ID: ${stateGeoId})`
    );
    setLoader(true);
    setIsDrilledDown(true);
    setCurrentMapLevel("state");

    // Update state name in parent component if the prop exists
    if (props.setStateName) {
      props.setStateName(stateName);
    }

    // Set the grid level to state
    setGridlevel({
      level: "state",
      geoId: stateGeoId,
      name: stateName,
    });
    fetchMapData(
      ["SLdistricts", `province_${stateGeoId}`],
      selectedCategoryId,
      "state",
      stateGeoId
    ).then(({ mapData, stats, params, paramnames }) => {
      if (!mapData || !mapData.features) {
        console.error("Invalid state map data received");
        setLoader(false);
        return;
      }

      const statsfinal =
        (stats["data"]
          ? setStats(stats["data"], params)
          : setStats(stats, params)) || {};

      let stateLabel = "";

      if (["production", "testing"].includes(dashboardType)) {
        stateLabel =
          Object.keys(statsfinal).length > 0
            ? UnitConverterWeight(
                Object.values(statsfinal).reduce(
                  (acc, curr) => acc + curr.value,
                  0
                )
              )
            : "N/A";
      } else {
        stateLabel =
          Object.keys(statsfinal).length > 0
            ? Object.values(statsfinal).reduce(
                (acc, curr) => acc + curr.label,
                0
              )
            : "N/A";
      }

      const districtData = [];
      const features = mapData.features;

      features.forEach(function (feature) {
        const districtGeoId = feature.properties.d_code;
        const districtName = toTitleCase(feature.properties.d_name);
        const districtStatistics = statsfinal[districtGeoId] || defaultstatsobj;
        feature.properties.name = toTitleCase(feature.properties.d_name);

        districtData.push({
          name: districtName,
          value: districtStatistics.value || 0,
          geoId: districtGeoId,
          stats: districtStatistics,
          type: "district",
        });
      });

      // Register the map data with ECharts
      echarts.registerMap(`province_${stateGeoId}`, mapData); //

      setCurrentStateData({
        geoId: stateGeoId,
        name: stateName,
        mapData: mapData,
        districtData: districtData,
        params: params,
        paramnames: paramnames,
      });

      let lastDrilledDownTooltipRegion = null;
      let lastDrilledDownTooltipContent = null;

      // Update the chart options
      setOptions({
        ...globaloptions,
        title: {
          text: `${maptitles(
            dashboardType,
            categoryname,
            stateName
          )} : ${stateLabel}`,
          right: 20,
          textStyle: {
            fontWeight: "bold",
            fontSize: "14px",
          },
        },
        tooltip: {
          trigger: "item",
          enterable: true,
          confine: true,
          triggerOn: "mousemove",
          formatter: function (params) {
            if (
              params.name === lastDrilledDownTooltipRegion &&
              lastDrilledDownTooltipContent
            ) {
              return lastDrilledDownTooltipContent;
            }
            lastDrilledDownTooltipRegion = params.name;
            let data = params.data || {};

            const name = params.name || data.name || "Unknown";

            let tooltipContent = `<div style="color:#0075ff; font-weight:bold; font-size:14px; margin-bottom:10px">${name}</div>`;

            if (dashboardType === "masters") {
              // For manufacturer data, just show the total count
              if (data.stats && data.stats.label) {
                tooltipContent += `<div style="display: block; color:#0075ff; padding:2px 0"><b>Total: ${data.stats.label}</b></div>`;
              } else if (data.value !== undefined) {
                tooltipContent += `<div style="display: block; color:#0075ff; padding:2px 0"><b>Total: ${
                  data.value || 0
                }</b></div>`;
              } else {
                tooltipContent += `<div style="color:gray; padding:2px 0">No data available</div>`;
              }
            }
            // For other dashboard types (premix/frk/miller)
            else if (
              data.stats &&
              data.stats.data &&
              paramnames &&
              paramnames.length > 0
            ) {
              // Show detailed parameters
              for (let i = 0; i < paramnames.length; i++) {
                if (paramnames[i]) {
                  tooltipContent += `<div style="display: block; color:black; padding:2px 0"> ${
                    paramnames[i]
                  }: <b>${data.stats.data[i] || "N/A"}</b></div>`;
                }
              }

              // Add the label/value as a summary if available
              // if (data.stats.label) {
              //   tooltipContent += `<div style="display: block; color:#0075ff; margin-top:5px; border-top:1px solid #eee; padding-top:5px"><b>Total: ${data.stats.label}</b></div>`;
              // }
            }
            // If we only have a label
            else if (data.stats && data.stats.label) {
              tooltipContent += `<div style="display: block; color:#0075ff; padding:2px 0"><b>${data.stats.label}</b></div>`;
            }
            // If we have a value
            else if (data.value !== undefined) {
              tooltipContent += `<div style="display: block; color:black; padding:2px 0">Value: <b>${
                data.value || 0
              }</b></div>`;
            }
            // No data available
            else {
              tooltipContent += `<div style="color:gray; padding:2px 0">No data available</div>`;
            }

            lastDrilledDownTooltipContent = tooltipContent;
            return tooltipContent;
          },
          backgroundColor: "rgba(255, 255, 255, 0.9)",
          borderColor: "#ccc",
          borderWidth: 1,
          padding: 10,
          textStyle: {
            color: "#333",
          },
        },
        visualMap: {
          min: 0,
          max: ["production", "testing"].includes(dashboardType)
            ? Math.max(...districtData.map((item) => item?.value || 0))
            : Math.max(...districtData.map((item) => item?.stats?.value || 0)),
          left: "left",
          bottom: "bottom",
          text: ["production", "testing"].includes(dashboardType)
            ? [
                UnitConverterWeight(
                  Math.max(...districtData.map((item) => item.value || 0))
                ),
                0,
              ]
            : [
                Math.max(
                  ...districtData.map((item) => item?.stats?.value || 0)
                ),
                0,
              ],
          calculable: false,
          inRange: {
            color: ["#F1E0DE", "#F6E8CA", "#FEF9B3", "#C5FCBD", "#73FED1"],
          },
          textStyle: {
            color: "#000",
          },
          formatter: function (value) {
            if (["production", "testing"].includes(dashboardType)) {
              return UnitConverterWeight(value);
            }
            return Math.round(value);
          },
        },
        series: [
          {
            name: stateName,
            type: "map",
            map: `province_${stateGeoId}`,
            aspectScale: 1,
            zoom: 0.9,
            roam: true,
            emphasis: {
              label: {
                show: true,
              },
              itemStyle: {
                areaColor: "#EEDD66",
              },
            },
            data: districtData,
            label: {
              show: true,
              formatter: "{b}",
              fontSize: 12,
              color: "#000",
            },
            layout: {
              hideOverlap: true,
            },
            layoutSize: "100%",
            layoutCenter: ["50%", "50%"],
            left: "center",
            top: "middle",
          },
        ],
        graphic: !isTheMonitorNotCountry
        ? [
          {
            type: "text",
            left: 60,
            top: 10,
            style: {
              text: "⬅ Back to Sri Lanka",
              fontSize: 14,
              // fontWeight: 'bold',
              fill: "#0075ff",
              cursor: "pointer",
            },
            onclick: function () {
              setIsDrilledDown(false);
              setCurrentMapLevel("country");
              setGridlevel({
                level: "country",
                geoId: 2,
                name: "Sri Lanka",
              });
              loadmap(["provinces"], {
                level: "country",
                geoId: 2,
                name: "Sri Lanka",
              });
            },
          },
        ] 
        : [],
      });

      setLoader(false);
    });
  };

  const fetchConsolidatedMapData = async (mapKeys) => {
    try {
      const { mapData, stats, params, paramnames } = await fetchMapData(
        mapKeys,
        selectedCategoryId,
        "country",
        2
        // year,
        //selectedDates
      );

      if (!mapData || !mapData.features) {
        console.error("Invalid mapData received:", mapData);
        return {
          mapData: {},
          stateData: [],
          params: [],
          paramnames: [],
          SL_title: "N/A",
        };
      }

      const SL_title = getLabel(stats) || "N/A";

      let statsfinal = {};

      if (stats) {
        // Determine if we need to extract data from stats["data"] or use stats directly
        const statsData = stats["data"] ? stats["data"] : stats;
        console.log("Stats data for processing:", statsData);

        // Process the stats data
        statsfinal = setStats(statsData, params) || {};
        console.log("Processed stats final:", statsfinal);
      } else {
        console.error("No stats data available");
      }

      // Process the data for ECharts
      const stateData = [];
      const features = mapData.features;

      features.forEach(function (feature) {
        // Extract state information from the GeoJSON feature
        const stateGeoId = feature.properties.p_code;
        const stateName = toTitleCase(feature.properties.p_name);

        // Try to find stats by state ID, converting to string since API returns string IDs
        let stateStatistics = statsfinal[String(stateGeoId)];

        // If not found, try as a number (just in case)
        if (!stateStatistics) {
          stateStatistics = statsfinal[stateGeoId];
        }

        // If still not found, use default
        if (!stateStatistics) {
          stateStatistics = defaultstatsobj;
        }

        // Make sure we have valid stats data
        const statsToUse = {
          ...stateStatistics,
          // Ensure data is an array
          data: Array.isArray(stateStatistics.data) ? stateStatistics.data : [],
          // Ensure label exists
          label: stateStatistics.label || stateName,
          // Ensure value exists
          value:
            stateStatistics.value !== undefined ? stateStatistics.value : 0,
        };

        stateData.push({
          name: stateName,
          value: statsToUse.value,
          geoId: stateGeoId,
          stats: statsToUse,
          drilldown: true,
          // Add explicit state properties for drill-down
          state: stateName,
          stateId: stateGeoId,
        });
      });

      // map.forEach(function (el, i) {
      //   el.geoId = el.properties.p_code;
      //   el.drilldown = ["SLdistricts", `province_${el.properties.p_code}`];
      //   const stateStatistics =
      //     statsfinal[el.properties.p_code] || defaultstatsobj;
      //   el.stats = stateStatistics;
      //   el.name = toTitleCase(el.properties.p_name);
      //   el.value = el.stats.value || 0;
      // });
      return { mapData, stateData, params, paramnames, SL_title };
    } catch (error) {
      console.error("Error in fetchConsolidatedMapData:", error);
      return {
        mapData: {},
        stateData: [],
        params: [],
        paramnames: [],
        SL_title: "N/A",
      };
    }
  };

  const loadmap = async (mapKeys, newGridLevel = gridlevel) => {
    const { mapData, stateData, params, paramnames, SL_title } =
      await fetchConsolidatedMapData(mapKeys);

    if (!mapData || !mapData.features || !stateData || stateData.length === 0) {
      console.error("Invalid map data received");
      setLoader(false);
      return;
    }
    // Register the map with ECharts

    setCurrentMapLevel("country");

    mapData.features.forEach((feature) => {
      if (feature.properties && feature.properties.p_name) {
        // Find matching state in stateData where State_LGD matches geoId
        const matchingState = stateData.find(
          (state) => String(feature.properties.p_code) === String(state.geoId)
        );

        // If found, set the name property from state.name
        if (matchingState) {
          feature.properties.name = matchingState.name;
        }
      }
    });
    echarts.registerMap("provinces", mapData);

    const processedStateData = stateData.map((state) => {
      // Find the corresponding feature in the map data
      const feature = mapData.features.find(
        (f) => String(f.properties.p_code) === String(state.geoId)
      );

      // If found, make sure the name matches exactly what's in the map
      if (feature) {
        return {
          ...state,
          name: state.name,
          // Store the original name as well for reference
          originalName: state.name,
          // Add map properties for better matching
          mapName: feature.properties.p_name,
          mapId: feature.properties.p_code,
        };
      }
      return state;
    });

    // Update the state variable
    setEnhancedStateData(processedStateData);
    let lastTooltipRegion = null;
    let lastTooltipContent = null;
    // Set the options for the chart
    setOptions({
      ...globaloptions,
      title: {
        text: `${maptitles(
          dashboardType,
          categoryname,
          "Sri Lanka"
        )} : ${SL_title}`,
        right: 20,
        textStyle: {
          fontWeight: "bold",
          fontSize: "14px",
        },
      },
      series: [
        {
          name: "Sri Lanka",
          type: "map",
          map: "provinces",
          aspectScale: 1,
          zoom: 1,
          roam: true,
          emphasis: {
            label: {
              show: true,
              fontSize: 14,
              fontWeight: "bold",
              color: "#000",
            },
            itemStyle: {
              areaColor: "#EEDD66",
            },
          },
          data: processedStateData,
          label: {
            show: true,
            fontSize: 11,
            color: "#111",
            formatter: function (params) {
              console.log("params for label in map", params);
              return params.name;
            },
            position: "middle",
            textStyle: {
              fontWeight: "bold",
            },
            emphasis: {
              show: true,
              fontSize: 12,
              fontWeight: "bold",
              color: "#000",
            },
            layout: {
              hideOverlap: true,
            },
          },
          itemStyle: {
            areaColor: function (params) {
              const value = params.data ? params.data.value || 0 : 0;
              const max = Math.max(
                ...processedStateData.map((item) => item.value || 0),
                100
              );
              const colors = [
                "#F1E0DE",
                "#F6E8CA",
                "#FEF9B3",
                "#C5FCBD",
                "#73FED1",
              ];
              const step = max / colors.length;
              const colorIndex = Math.min(
                Math.floor(value / step),
                colors.length - 1
              );

              return colors[colorIndex];
            },
            // borderColor: '#b6b6a7',
            borderWidth: 0.2,
          },
          left: "center",
          top: "middle",
        },
      ],
      tooltip: {
        trigger: "item",
        enterable: true,
        confine: true,
        triggerOn: "mousemove",
        formatter: function (params) {
          if (params.name === lastTooltipRegion && lastTooltipContent) {
            return lastTooltipContent;
          }
          lastTooltipRegion = params.name;
          let data = params.data || {};

          if (params.dataIndex === -1 && params.name) {
            console.log(
              "DataIndex is -1, need to find matching data for:",
              params.name
            );

            const matchingState = processedStateData.find((state) => {
              // Try exact match on name
              if (state.name === params.name) return true;

              // Try case-insensitive match
              if (state.name.toLowerCase() === params.name.toLowerCase())
                return true;

              // Try matching with originalName
              if (state.originalName && state.originalName === params.name)
                return true;

              // Try matching with mapName
              if (state.mapName && state.mapName === params.name) return true;

              return false;
            });

            if (matchingState) {
              data = matchingState;
              console.log(
                "Found matching state data for region with dataIndex -1:",
                data
              );
            } else {
              console.log("No matching state found for name:", params.name);
              lastTooltipContent = `<div style="color:#0075ff; font-weight:bold; font-size:14px">${params.name}</div><br/><div>No data available</div>`;
              return lastTooltipContent;
            }
          }
          // If we have data directly from params.data, use it
          else if (params.data) {
            // console.log('Direct data available in params.data:', params.data);
          }
          // If no data in params, try to find it by name in enhancedStateData
          else if (params.name) {
            // console.log('No params.data, searching by name:', params.name);

            const matchingState = processedStateData.find(
              (state) =>
                state.name === params.name ||
                state.name.toLowerCase() === params.name.toLowerCase()
            );

            if (matchingState) {
              data = matchingState;
              // console.log('Found matching state data by name:', data);
            } else {
              console.log("No matching state found for name:", params.name);
              lastTooltipContent = `<div style="color:#0075ff; font-weight:bold; font-size:14px">${params.name}</div><br/><div>No data available</div>`;
              return lastTooltipContent;
            }
          } else {
            // console.log('No params.data or params.name available');
            lastTooltipContent = "No data available";
            return lastTooltipContent;
          }

          const name = params.name || data.name || "Unknown";

          // Create tooltip content similar to Highcharts implementation
          let tooltipContent = `<div style="color:#0075ff; font-weight:bold; font-size:14px; margin-bottom:10px">${name}</div>`;

          // Handle different dashboard types differently
          if (dashboardType === "masters") {
            // For manufacturer data, just show the total count
            if (data.stats && data.stats.label) {
              tooltipContent += `<div style="display: block; color:#0075ff; padding:2px 0"><b>Total: ${data.stats.label}</b></div>`;
            } else if (data.value !== undefined) {
              tooltipContent += `<div style="display: block; color:#0075ff; padding:2px 0"><b>Total: ${
                data.value || 0
              }</b></div>`;
            } else {
              tooltipContent += `<div style="color:gray; padding:2px 0">No data available</div>`;
            }
          }
          // For other dashboard types (premix/frk/miller)
          else if (
            data.stats &&
            data.stats.data &&
            paramnames &&
            paramnames.length > 0
          ) {
            // Show detailed parameters
            for (let i = 0; i < paramnames.length; i++) {
              if (paramnames[i]) {
                tooltipContent += `<div style="display: block; color:black; padding:2px 0"> ${
                  paramnames[i]
                }: <b>${data.stats.data[i] || "N/A"}</b></div>`;
              }
            }
          }
          // If we only have a label
          else if (data.stats && data.stats.label) {
            tooltipContent += `<div style="display: block; color:#0075ff; padding:2px 0"><b>${data.stats.label}</b></div>`;
          }
          // If we have a value
          else if (data.value !== undefined) {
            tooltipContent += `<div style="display: block; color:black; padding:2px 0">Value: <b>${
              data.value || 0
            }</b></div>`;
          }
          // No data available
          else {
            tooltipContent += `<div style="color:gray; padding:2px 0">No data available</div>`;
          }

          lastTooltipContent = tooltipContent;
          return tooltipContent;
        }, //
        backgroundColor: "rgba(255, 255, 255, 0.9)",
        borderColor: "#ccc",
        borderWidth: 1,
        padding: 10,
        textStyle: {
          color: "#333",
        },
      },
      visualMap: {
        min: 0,
        max: ["production", "testing"].includes(dashboardType)
          ? Math.max(...processedStateData.map((item) => item?.value || 0))
          : Math.max(
              ...processedStateData.map((item) => item?.stats?.value || 0)
            ),
        left: "left",
        bottom: "bottom",
        text: ["production", "testing"].includes(dashboardType)
          ? [
              UnitConverterWeight(
                Math.max(...processedStateData.map((item) => item.value || 0))
              ),
              0,
            ]
          : [
              Math.max(
                ...processedStateData.map((item) => item?.stats?.value || 0)
              ),
              0,
            ],
        calculable: false,
        inRange: {
          color: ["#F1E0DE", "#F6E8CA", "#FEF9B3", "#C5FCBD", "#73FED1"],
        },
        textStyle: {
          color: "#000",
        },
        formatter: function (value) {
          if (["production", "testing"].includes(dashboardType)) {
            return UnitConverterWeight(value);
          }
          return Math.round(value);
        },
      },
    });

    setLoader(false);

    console.log("gridlevel in loadmap is ", gridlevel);
    // If we need to drill down based on gridlevel
    if (newGridLevel && newGridLevel.level === "state" && newGridLevel.geoId) {
      // Get state name from map data instead of using gridlevel.name
      const stateFeature = mapData.features.find(
        (feature) =>
          String(feature.properties.p_code) === String(newGridLevel.geoId)
      );

      let stateName = newGridLevel.name;
      // If we found the state in map data, use its name
      if (stateFeature && stateFeature.properties.p_name) {
        stateName = stateFeature.properties.p_name;
      } else {
        // Try to find state name in stateData
        const matchingState = stateData.find(
          (state) => String(state.geoId) === String(newGridLevel.geoId)
        );
        if (matchingState && matchingState.name) {
          stateName = matchingState.name;
        }
      }

      loadDrilledDownMap(newGridLevel.geoId, stateName);
    }
  };

  function toTitleCase(str) {
    return str.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  }
  useEffect(() => {
    if (currentMapLevel === "country" || !isDrilledDown) {
      loadmap(["provinces"]);
    }
    // If we're drilled down to a state, reload that state map
    else if (currentMapLevel === "state" && isDrilledDown && currentStateData) {
      loadDrilledDownMap(currentStateData.geoId, currentStateData.name);
    }
  }, [
    dashboardType,
    categoryname,
    selectedCategoryId,
    selectedTab,
    selectedDates,
    // , year
  ]);

  // Event handler for map click to handle drill-down
  const onChartClick = (params) => {
    if (isDrilledDown) {
      return;
    }
    console.log("Map clicked:", params);

    // Process clicks on data points (states/districts)
    if (params.data) {
      const stateGeoId = params.data.geoId || params.data.stateId;
      const stateName = params.name || params.data.name;

      if (stateGeoId && stateName) {
        loadDrilledDownMap(stateGeoId, stateName);
      } else {
        console.error(
          "Missing geoId or name for state in params.data:",
          params.data
        );
      }
    }
    // If no data in params, try to find it by name in processedStateData
    else if (params.name) {
      const matchingState = enhancedStateData.find(
        (state) =>
          state.name === params.name ||
          state.name.toLowerCase() === params.name.toLowerCase()
      );

      if (matchingState && matchingState.drilldown) {
        const stateGeoId = matchingState.geoId || matchingState.stateId;
        const stateName = matchingState.name;

        if (stateGeoId && stateName) {
          loadDrilledDownMap(stateGeoId, stateName);
        } else {
          console.error(
            "Missing geoId or name for matched state:",
            matchingState
          );
        }
      } else {
        console.log(
          "No matching state found or state does not support drill-down"
        );
      }
    } else {
      console.log("No data or name available for click event");
    }
  };

  // Event handler for chart instance
  const onChartInit = (chart) => {
    chartRef.current = chart;
  };

  return loader ? (
    <Box
      component={Paper}
      m={1}
      sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
    >
      <CircularProgress />
    </Box>
  ) : (
    <Box component={Paper} m={1}>
      <ReactECharts
        style={{ height: "calc(100vh - 170px)" }}
        option={options}
        onEvents={{
          click: onChartClick,
          mouseover: (params) => {},
        }}
        onChartReady={onChartInit}
        notMerge={true}
        lazyUpdate={false}
        opts={{
          renderer: "svg", //canvas can also be used
        }}
      />
    </Box>
  );
}

Mapcomponent.propTypes = {
  dashboardType: PropTypes.string,
  categoryname: PropTypes.string,
  selectedCategoryId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  setGridlevel: PropTypes.func,
  geoId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  gridlevel: PropTypes.object,
  selectedTab: PropTypes.string,
  selectedDates: PropTypes.object,
  setStateName: PropTypes.func
};
